import React, { useEffect, useState } from "react";
import "./UserManagementTable.css";
import { MdEdit } from "react-icons/md";
import { FaTrashAlt, FaKey } from "react-icons/fa";
import UserEditForm from "./UserEditForm/UserEditForm";
import ResetPasswordForm from "./ResetPasswordForm/ResetPasswordForm";

function UserManagementTable({ userData }) {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userToDelete, setUserToDelete] = useState(null);
  const [userToResetPassword, setUserToResetPassword] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_FLASK_API_URL}/admin/users`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => setUsers(data))
      .catch((err) => console.error(err));
  }, [userData]);

  const updateUser = (userId, updatedData) => {
    fetch(
      `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/admin/users/edit/${userId}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(updatedData),
      }
    ).then(() => {
      setUsers((prev) =>
        prev.map((u) => (u.id === userId ? { ...u, ...updatedData } : u))
      );
    });
  };

  const deleteUser = (userId) => {
    fetch(
      `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/admin/users/delete/${userId}`,
      {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ active: false }),
      }
    ).then(() => {
      setUsers((prev) => prev.filter((u) => u.id !== userId));
    });
  };

  return (
    <div className="user-management-table">
      <h3>All Users</h3>
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Username</th>
              <th>Email</th>
              <th>Role</th>
              <th>Status</th>
              {/* <th>Total Score</th> */}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => {
              return (
                <tr key={user.id}>
                  <td className="overflow-cell">{user.username}</td>
                  <td className="overflow-cell">{user.email}</td>
                  <td>{user.role}</td>
                  <td>
                    {user.status.toLowerCase() === "active"
                      ? "Active"
                      : "Inactive"}
                  </td>
                  {/* <td><UserScoresTable user={user} /></td> */}
                  <td>
                    {/* Edit, reset password, and delete buttons */}
                    <button onClick={() => setSelectedUser(user)}>
                      <MdEdit />
                    </button>
                    <button onClick={() => setUserToResetPassword(user)}>
                      <FaKey />
                    </button>
                    <button
                      className="red-button"
                      onClick={() => setUserToDelete(user)}
                    >
                      <FaTrashAlt />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {selectedUser && (
        <UserEditForm
          user={selectedUser}
          onClose={() => setSelectedUser(null)}
          onSave={(updatedData) => {
            updateUser(selectedUser.id, updatedData);
            setSelectedUser(null);
          }}
        />
      )}

      {userToResetPassword && (
        <div className="modal">
          <div className="modal-content">
            <button
              className="modal-close"
              onClose={() => setUserToResetPassword(null)}
            >
              ×
            </button>
            <h3>Reset Password for {userToResetPassword.username}</h3>
            <ResetPasswordForm
              user={userToResetPassword}
              onClose={() => setUserToResetPassword(null)}
              onSuccess={() => setUserToResetPassword(null)}
            />
          </div>
        </div>
      )}

      {userToDelete && (
        <div className="modal">
          <div className="modal-content">
            <button
              className="modal-close"
              onClick={() => setUserToDelete(null)}
            >
              ×
            </button>
            <h3>Confirm Deletion</h3>
            <p>
              Are you sure you want to delete user{" "}
              <strong>{userToDelete.username}</strong>?
            </p>
            <div className="modal-buttons">
              <button
                className="red-button"
                onClick={() => {
                  deleteUser(userToDelete.id);
                  setUserToDelete(null);
                }}
              >
                Delete
              </button>
              <button
                className="red-button"
                onClick={() => setUserToDelete(null)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserManagementTable;
